import { createFileRoute } from '@tanstack/react-router'
import { MedicationAlerts } from '@/features/medication-alerts'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/medication-alerts/')({
  beforeLoad: requireAdmin,
  component: MedicationAlerts,
})
